import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=060c4b2c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060c4b2c')) {
      api.createRecord('060c4b2c', component.options)
    } else {
      api.reload('060c4b2c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=060c4b2c&", function () {
      api.rerender('060c4b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f0EW6PNm9von/JS/pricehelp.vue"
export default component.exports